import { noop } from 'lodash';
import { HTMLMediaElementEvents, HTMLMediaElementReadyState, } from '../constants/html-video-element';
export const playVideo = async (video) => {
    return new Promise(async (resolve) => {
        if (video.readyState === HTMLMediaElementReadyState.HaveEnoughData) {
            video.play();
            return resolve();
        }
        const listener = async () => {
            video.play();
            resolve();
        };
        video.addEventListener(HTMLMediaElementEvents.CanPlayThrough, listener, {
            once: true,
        });
    });
};
export const playOnLoadedData = (el, delayMs = 200) => {
    const play = () => {
        el.removeEventListener(HTMLMediaElementEvents.LoadedData, play);
        setTimeout(() => el.play().catch(noop), delayMs);
    };
    el.addEventListener(HTMLMediaElementEvents.LoadedData, play);
};
export const doesVideoElHaveAudio = (el) => {
    return !!getVideoElAudioTrack(el);
};
export const getVideoElAudioTrack = (el) => {
    const mediaStream = getVideoElMediaStream(el);
    if (!mediaStream)
        return null;
    return mediaStream.getAudioTracks()[0] || null;
};
export const getVideoElVideoTrack = (el) => {
    const mediaStream = getVideoElMediaStream(el);
    if (!mediaStream)
        return null;
    return mediaStream.getVideoTracks()[0] || null;
};
export const getVideoElMediaStream = (el) => {
    return el.srcObject;
};
export const isSoundPlaying = (el) => {
    return el.muted || el.paused;
};
export const resumeSoundPlayback = (el) => {
    el.muted = false;
    el.play().catch(noop);
};
